<header id="site-header">
    <div class="inner-content">
        <div class="flex-container">
            <button type="button" class="btn logo-wrapper" [routerLink]="['/']">
                <img src="./assets/imgs/Shahrnik_Logo_Public_new.png" alt="اتحادیه سراسری تعاونی صیادی ایران" width="48">
                <span>اتحادیه سراسری تعاونی صیادی ایران</span>
            </button>

            <div class="dropdown-container">
                <button class="btn" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                    <mat-icon>menu</mat-icon>
                </button>

                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li *ngIf="specialistUser" class="dropdown-item" [routerLink]="['/specialist-verification']">
                        {{specialistUser.strFullName}}
                    </li>
                    <li *ngIf="specialistUser" class="dropdown-item" [routerLink]="['/specialist-change-password']">
                        تغییر رمز عبور
                    </li>
                    <li *ngIf="!specialistUser" class="dropdown-item" [routerLink]="['/specialist-login']">
                        ورود کارشناس
                    </li>
                    <li *ngIf="specialistUser" class="dropdown-item" [routerLink]="['/specialist-my-registration']">
                        ثبت نامی های من
                    </li>
                    <li class="dropdown-item" [routerLink]="['/general']">
                        قوانین و مقررات
                    </li>
                    <li class="dropdown-item" [routerLink]="['/about']">
                        درباره ما
                    </li>
                    <li *ngIf="isLogin || specialistUser" class="dropdown-item" (click)="logOut()">
                        خروج
                    </li>
                </ul>
            </div>
        </div>
    </div>
</header>

<router-outlet></router-outlet>